module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABFElEQVQ4je3UMUpDQRDG8V9C9CkahXgBCxE8hI0IdnbaCB4iJ/Ag2tlaCd7AQhBEQbQKGNTawqBGcS3eBp6r4T1MSqeZnW93/jsLO1MLIZziDG1jsFoIIeAWK+MANqJ/jH4Cu2jhGid/BQ5sC/uFeBF3owAXkniuJL+JDczgChcp8CWJ30uAbezF9QeaKXCYZdjBNM7lvwLmC2fqyKoCt3FQrASvvr+oh896RWArrWTYwarAH5WMCqxs/8DxAyeTuPGLnhXyslRPgWnr9aJ/Sy7tx3U/1Qfz8BibcWNVPhQ6uCkkrMlb7xL3iT4V9YcBsI9DeTt15B83w3J83nPUg3yyLEXYE7pRnyWf2EdYVz6qqlj3C6wbRGjmzolyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/20.png
// module id = gT3h
// module chunks = 0